import { NextSeo } from 'next-seo';
import TrademarkingPage from '_components/composed/pages/TrademarkingPage';

export default function Trademarking() {
  return (
    <>
      <NextSeo
        title="Trademark Registration with Incorpified - Protect Your Brand"
        description="Protect your brand with Incorpified’s Trademarking services. Secure your intellectual property with our efficient and affordable trademark registration."
      />
      <TrademarkingPage />
    </>
  );
}
